// TODO(SuperPaintman): Remove those rules later
/* tslint:disable:strict-type-predicates */

type ApiErrorCode = number

type ApiResponse = {
  status: number
  data: {
    /**
     * Домен? "UserData"
     */
    domain: string
    /**
     * Код ошибки
     */
    code: ApiErrorCode
    /**
     * Общая базовая ошибка
     */
    err?: string
    /**
     * Время, через которое можем повторить запрос
     */
    delay?: number
    /**
     * Остальной набор ошибок
     */
    errors: {
      [k: string]: string[]
    }
    /**
     * Прочие поля от сервера
     */
    payload?: any
  }
}

export class ApiError {
  name: string
  stack?: string
  message: string

  apiResponse: ApiResponse

  constructor (apiResponse: ApiResponse, errorMessage: string) {
    const error = new Error(errorMessage)

    this.apiResponse = apiResponse
    this.name = 'ApiError'
    this.stack = error.stack
    this.message = error.message
  }

  get data () {
    return this.apiResponse === undefined
      ? undefined
      : this.apiResponse.data
  }

  get text (): string | null {
    return this.data === undefined
      ? 'Произошла ошибка, попробуйте ещё раз'
      : this.data.err !== undefined
        ? this.data.err
        : null
  }

  get status () {
    return this.apiResponse === undefined
      ? undefined
      : this.apiResponse.status
  }

  get code (): ApiErrorCode | null {
    return this.data === undefined || this.data.code === undefined
      ? null
      : this.data.code
  }

  getFieldText (field?: string): string | null {
    if (field === undefined) {
      return null
    }

    if (this.data && this.data.errors && this.data.errors[field]) {
      return this.data.errors[field].join('; ')
    }

    return null
  }
}
